import React, { useEffect, useRef } from 'react'
import classNames from 'classnames'
import './chevron.scss'

export interface ChevronProps {
    direction: 'up' | 'down'
    size?: number
    durationMs?: number
    className?: string
    strokeWidth?: number
    absoluteStrokeWidth?: boolean
}

export const Chevron = ({
    direction = 'down',
    size = 16,
    durationMs = 150,
    className,
    strokeWidth = 2,
    absoluteStrokeWidth = true,
}: ChevronProps) => {
    const viewBoxSize = 20
    const adjustedStrokeWidth = (viewBoxSize / size) * strokeWidth

    const upPoints = '1,14 10,6 19,14'
    const downPoints = '1,6 10,15 19,6'
    const upAnimation = useRef<SVGAnimateElement | null>(null)
    const downAnimation = useRef<SVGAnimateElement | null>(null)
    const isFirstRender = useRef(true)
    const initialDirection = useRef<string>(direction)

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false
            return
        }

        if (direction === 'up') {
            upAnimation.current?.beginElement()
        } else {
            downAnimation.current?.beginElement()
        }
    }, [direction])

    return (
        <svg
            className={classNames(className, 'chevron', direction)}
            width={size}
            height={size}
            viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
            strokeWidth={absoluteStrokeWidth ? adjustedStrokeWidth : strokeWidth}
            xmlns="http://www.w3.org/2000/svg"
            style={{ '--durationMs': durationMs } as React.CSSProperties}
        >
            <polyline
                points={initialDirection.current === 'up' ? upPoints : downPoints}
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <animate
                    ref={upAnimation}
                    values={`${downPoints}; ${upPoints}`}
                    dur={`${durationMs}ms`}
                    attributeName="points"
                    fill="freeze"
                    begin="indefinite"
                    calcMode="spline"
                    keyTimes="0; 1"
                    keySplines="0 0 0.58 1"
                />
                <animate
                    ref={downAnimation}
                    values={`${upPoints}; ${downPoints}`}
                    dur={`${durationMs}ms`}
                    attributeName="points"
                    fill="freeze"
                    begin="indefinite"
                    calcMode="spline"
                    keyTimes="0; 1"
                    keySplines="0 0 0.58 1"
                />
            </polyline>
        </svg>
    )
}
